export default __webpack_public_path__ + "static/media/image_02.0c293340.jpg";